import React from "react";
import { addLabels } from "../../../../lib/Checkboxes";

export const AutoCompleteSuggestions = ({ suggestions, onSelectSuggestion }) => {
  return (
    <section className="position-absolute bg-white border border-dark small cursor-default autocomplete-dropdown">
      <div className="max-height-333 overflow-y-auto">
        {suggestions.map(addLabels).map((suggestion, index) => (
          <Suggestion key={index} suggestion={suggestion} onSelectSuggestion={onSelectSuggestion} />
        ))}
      </div>
    </section>
  );
};

const Suggestion = ({ suggestion, onSelectSuggestion }) =>
  suggestion.heading ? (
    <div className="pl-1 pt-2 text-muted">{suggestion.heading}</div>
  ) : (
    <div onMouseDown={onSelectSuggestion(suggestion)} className={`pl-2 ${hoverClass()}`}>
      {suggestion.label}
    </div>
  );
const hoverClass = () => (window.navigator.userAgent.indexOf("Edg") > -1 ? "hover-edge" : "hover-webkit");
